import { createRoot } from "react-dom/client";
import App from "./App";
import { trackOutboundLinkClicks } from "./lib/analytics";
import "./index.css";

trackOutboundLinkClicks();

createRoot(document.getElementById("root")!).render(<App />);
